<script setup lang="ts">
import { enUS } from 'date-fns/locale'
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker'

import { faClock } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { AppText } from '@shared/ui/typography'
import { IconContainer, RowSlot } from '@shared/ui/other'

import { useTutorKanbanPickerDeadline } from '../../model/tutor-kanban-picker-deadline.hook'

defineOptions({
  name: 'TutorKanbanPickerDeadline',
})

const {
  refDate,
  refStartTime,
  refMinDate,
  refExpired,
  refUpcoming,
  refStageAge,
  handleChange,
} = useTutorKanbanPickerDeadline()
</script>

<template>
  <RowSlot label="Deadline">
    <div :class="['tkb-picker-deadline', { expired: refExpired, upcoming: refUpcoming }]">
      <Datepicker
        v-model="refDate"
        :min-date="refMinDate"
        :locale="enUS"
        :week-start="1"
        :formats="{ input: 'MMM dd, yyyy HH:mm' }"
        :start-time="refStartTime"
        :clearable="true"
        :time-config="{ timePickerInline: true }"
        placeholder="Select date"
        :teleport-center="true"
        @update:model-value="handleChange"
      >
        <template #input-icon>
          <IconContainer>
            <FontAwesomeIcon :icon="faClock" />
          </IconContainer>
        </template>
        <template #clock-icon>
          <IconContainer>
            <FontAwesomeIcon :icon="faClock" />
          </IconContainer>
        </template>
      </Datepicker>
      <AppText
        v-if="refStageAge"
        name="body2"
        color="slate-500"
        class="tkb-picker-deadline__age"
      >
        Card age: {{ refStageAge }}
      </AppText>
    </div>
  </RowSlot>
</template>

<style scoped lang="scss" src="./TutorKanbanPickerDeadline.scss" />
